import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { storageGetItem } from '../utils/local-storage';
import { ACCESS_TOKEN } from '../utils/storage-keys';
import Dashboard from './Dashboard/Dashboard';
import Home from './Home/Home';
import Referral from './Referral/Referral';
import Url from './Url/Url';
import Payout from './Payout/Payout';
import Visit from './Visit/Visit';
import Creative from './Creative/Creative';
import Login from './Login/Login';
import NotFound from './NotFound';
import UserPending from './UserPending';
import Profile from './Profile/Profile';
import HomeLeader from './Home/HomeLeader';

function AppRoutes() {
  const isLoggedIn = storageGetItem(ACCESS_TOKEN);
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    if (isLoading) {
      setIsLoading(false);
      navigate(location.pathname);
    }
  }, [navigate, isLoading, location]);

  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        <Route index element={<Home />} />
        <Route path="/leader" element={<HomeLeader />} />
        <Route path="/urls" element={<Url />} />
        <Route path="/referrals" element={<Referral />} />
        <Route path="/payouts" element={<Payout />} />
        <Route path="/visits" element={<Visit />} />
        <Route path="/creatives" element={<Creative />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/login" element={(isLoggedIn) ? <Navigate to='/'/> : <Login />} />
      <Route path="/pending" element={(isLoggedIn) ? <Navigate to='/'/> : <UserPending />} />
    </Routes>
  )
}

export default AppRoutes;